module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/$.library.js
// module id = 77
// module chunks = 0